import { CONTACT } from "../utils/contact";
import WhatsAppIcon from "./WhatsAppIcon";
import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  return (
    <a
      href={CONTACT.whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <WhatsAppIcon className="whatsapp-float-icon" />
    </a>
  );
}
